import * as types from '../constants/actionTypes';
import axios from 'axios';
import Flagship from '../core/flagship';
import { actions } from 'react-redux-form';
import {browserHistory} from 'react-router';

export function login(payload, redirect = '/') {

  return function(dispatch) {
    // thunk
    let url = Flagship.config.apiBase + 'login';

    dispatch(actions.change("login.failed",false));
    axios.post(url,payload).then( function(response) {
      if (response.data.success === true) {

        browserHistory.push(redirect);

        return dispatch({
            type: types.LOGIN,
            token: response.data.token,
            userId: response.data.userId,
            username: response.data.username,
            userFirstName: response.data.first_name,
            userLastName: response.data.last_name,
            userPhoto: response.data.photo,
            userRole: response.data.role,
            userMarket: response.data.market
        });

      } else {
          dispatch(actions.change("login.message",response.data.message));
          dispatch(actions.change("login.failed",true));
      }
    }).catch(function (err) {
      return dispatch(actions.change("login.message","The Flagship API is down. " + err));
    });
  };
}

export function checkToken(token) {

  return function (dispatch) {
    // thunk
    let url = Flagship.config.apiBase + 'validate-token';

    axios.post(url, {token}).then(function (response) {
      if (response.data.success === true) {

        return dispatch({
            type: types.VALID_TOKEN,
            token: response.data.token,
            accessLevel: response.data.accessLevel,
            userId: response.data.userId,
            username: response.data.username,
            userFirstName: response.data.first_name,
            userLastName: response.data.last_name,
            userPhoto: response.data.photo,
            userRole: response.data.role,
            userMarket: response.data.market
        });
      } else {
        browserHistory.push('/login');

        return dispatch({
          type: types.INVALID_TOKEN,
          token: response.data.token
        });
      }
    }).catch(function() {
        browserHistory.push('/login');
    });
  };
}

export function logout() {
    return function(dispatch) {
        dispatch({
          type: types.LOGOUT
        });
  };
}


export function clearErrors() {
  return function(dispatch) {
    dispatch({
      type: types.CLEAR_ERRORS
    });
  };
}

export function clearNotification() {
    return function(dispatch) {
        dispatch({
            type: types.CLEAR_NOTIFICATION
        });
    };
}

export function resizeWindow(size) {
    return function(dispatch) {
        dispatch({
            type: types.RESIZE_WINDOW,
            size
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/appActions.js